export default __webpack_public_path__ + "static/media/right_trees.a8004d18.svg";